import { Selector } from "@ngxs/store";

import { PushNotificationStatus } from "../models/push-notification-status.enum";
import { PushNotification } from "../models/push-notification.model";
import { PushNotificationState, PushNotificationStateModel } from "./push-notification.state";

export class PushNotificationSelectors {
    @Selector([PushNotificationState])
    public static allNotifications(state: PushNotificationStateModel): PushNotification[] {
        return state?.notifications || [];
    }

    @Selector([PushNotificationState])
    public static unreadNotifications(state: PushNotificationStateModel): PushNotification[] {
        return state?.notifications?.filter((n) => n.status === PushNotificationStatus.Unread) || [];
    }

    @Selector([PushNotificationState])
    public static unreadCount(state: PushNotificationStateModel): number {
        return state?.unreadCount || 0;
    }

    @Selector([PushNotificationState])
    public static hasUnreadNotifications(state: PushNotificationStateModel): boolean {
        return state && state.unreadCount > 0;
    }
}


